enum UsageIntervalType {
  Day = "Day",
  Week = "Week",
  Month = "Month",
}

export default UsageIntervalType;
